import React from "react";
import { ShieldCheck, Clock, MapPin, Flame, Award } from "lucide-react";
import { BUSINESS } from "../../data/business";

export default function TrustBar() {
  return (
    <section className="abc-bg-pale border-y border-slate-100" data-testid="trust-bar">
      <div className="abc-container py-5 flex flex-nowrap items-center justify-center lg:justify-between gap-x-2 sm:gap-x-6 gap-y-2 text-xs sm:text-sm">
        <div className="flex items-center gap-2 text-[#1A1D21] whitespace-nowrap" data-testid="trust-item-specialists"><Flame className="w-4 h-4 shrink-0 text-[#E31D2B]" /> Drain &amp; Sewer Specialists</div>
        <div className="flex items-center gap-2 text-[#1A1D21] whitespace-nowrap" data-testid="trust-item-experience"><Award className="w-4 h-4 shrink-0 text-[#E31D2B]" /> 30+ Years Experience</div>
        <div className="hidden md:flex items-center gap-2 text-[#1A1D21] whitespace-nowrap" data-testid="trust-item-licensed"><ShieldCheck className="w-4 h-4 shrink-0 text-[#54616E]" /> Licensed &amp; Insured</div>
        <div className="hidden lg:flex items-center gap-2 text-[#1A1D21] whitespace-nowrap" data-testid="trust-item-area"><MapPin className="w-4 h-4 shrink-0 text-[#54616E]" /> Baltimore &amp; DC metros</div>
        <div className="hidden xl:flex items-center gap-2 text-[#1A1D21] whitespace-nowrap" data-testid="trust-item-hours"><Clock className="w-4 h-4 shrink-0 text-[#E31D2B]" /> {BUSINESS.hours.weekdays}</div>
      </div>
    </section>
  );
}
